import type { ElementType } from 'react';
import styled, { css, keyframes } from 'styled-components';

export interface SvgWrapperProps {
  $isAnimated: boolean;
}

export interface TextProps {
  $isLight: boolean;
}

const gradientRotation = () =>
  keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '19.95%': { transform: 'rotate(90deg)' },
    '36.575%': { transform: 'rotate(-90deg)' },
    '60.95%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(0deg)' },
  });

const wink = () =>
  keyframes({
    '0%': { clipPath: 'inset(-1px -1px -1px -1px)' },
    '77.5%': { clipPath: 'inset(-1px -1px -1px -1px)' },
    '81.8%': { clipPath: 'inset(50% -1px 50% -1px)' },
    '85.12%': { clipPath: 'inset(-1px -1px -1px -1px)' },
    '86.45%': { clipPath: 'inset(-1px -1px -1px -1px)' },
    '90.77%': { clipPath: 'inset(50% -1px 50% -1px)' },
    '94.1%': { clipPath: 'inset(-1px -1px -1px -1px)' },
    '100%': { clipPath: 'inset(-1px -1px -1px -1px)' },
  });

const arc = () =>
  keyframes({
    '0': { transform: 'translate(0px, 0px)' },
    '3.325%': { transform: 'translate(0px, 0px)' },
    '14.4%': { transform: 'translate(-0.25px, -0.25px)' },
    '19.95%': { transform: 'translate(-0.25px, -0.25px)' },
    '31%': { transform: 'translate(-0.25px, 0.25px)' },
    '36.575%': { transform: 'translate(-0.25px, 0.25px)' },
    '48.74%': { transform: 'translate(0px, 0px)' },
    '100%': { transform: 'translate(0px, 0px)' },
  });

const dot = () =>
  keyframes({
    '0': { transform: 'translate(0px, 0px)' },
    '3.325%': { transform: 'translate(0px, 0px)' },
    '14.4%': { transform: 'translate(-1.125px, -1.125px)' },
    '19.95%': { transform: 'translate(-1.125px, -1.125px)' },
    '31%': { transform: 'translate(-1.25px, 0.5px)' },
    '36.575%': { transform: 'translate(-1.25px, 0.5px)' },
    '48.74%': { transform: 'translate(0px, 0px)' },
    '100%': { transform: 'translate(0px, 0px)' },
  });

export const GradientBackground = styled.g(() => ({}));

export const Icon = styled.g({});

export const Arc = styled.path(({ theme: { color } }) => ({
  fill: color.content.reversed.default(),
}));

export const Dot = styled.circle(({ theme: { color } }) => ({
  fill: color.content.reversed.default(),
}));

export const Text = styled.path<TextProps>(({ $isLight, theme: { color } }) => ({
  fill: $isLight ? color.content.reversed.default() : color.content.primary.default(),
}));

export const InnerCircle = styled.circle(({ theme: { color } }) => ({
  fill: color.content.primary.default(),
}));

const withAnimation = (Component: ElementType) =>
  styled(Component)<{ $active: boolean }>(
    ({ $isAnimated }) =>
      $isAnimated &&
      css`
        ${GradientBackground} {
          transform-origin: 4px 4px;
          animation: ${gradientRotation} 3s cubic-bezier(0.2, 1.06, 0.61, 0.97);
        }

        ${Icon} {
          animation: ${wink} 3s cubic-bezier(0.2, 1.06, 0.61, 0.97);
        }

        ${Arc} {
          animation: ${arc} 3s cubic-bezier(0.2, 1.06, 0.61, 0.97);
        }

        ${Dot} {
          animation: ${dot} 3s cubic-bezier(0.2, 1.06, 0.61, 0.97);
        }
      `,
  );

export const SvgWrapper = withAnimation(
  styled.svg<SvgWrapperProps>(() => ({
    width: '100%',
    height: '100%',
  })),
);
